import { GraphQLQueryClass } from "@harea/component";
import { TContract } from "@harea/component";

export class EmployeeOrganisationQuery
    implements GraphQLQueryClass<TContract, TResponse>
{
    queryKey: string = "Harea.TimeOff.Employee.Organisation.Query";

    gql: string = `
        query EmployeeOrganisationQuery($employeeId: Float) {
            contract(filter: {
                data: { user: { id: $employeeId }, isActive: true }
            }) {
                id
                organisation {
                    id
                    profile {
                        unpaidLeaveMode
                        allowExceptionalAbsence
                    }
                }
            }
        }
    `;

    variables?: any;

    constructor(variables?: any) {
        this.variables = variables;
    }

    mapFn(data: TResponse): TContract {
        return data.contract;
    }
}

export type TResponse = {
    contract: TContract;
};
